module.exports = {"411522001":"弦山街道","411522002":"紫水街道","411522101":"十里镇","411522102":"寨河镇","411522103":"孙铁铺镇","411522104":"马畈镇","411522105":"泼陂河镇","411522106":"白雀园镇","411522107":"砖桥镇","411522201":"仙居乡","411522203":"北向店乡","411522204":"罗陈乡","411522206":"殷棚乡","411522207":"南向店乡","411522208":"晏河乡","411522210":"凉亭乡","411522212":"斛山乡","411522213":"槐店乡","411522215":"文殊乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411522.json
// module id = 1521
// module chunks = 0